import api from './api';
import { getOrganizationSettings } from './utils/storage';

export async function getWallets({ items_per_page = 15 } = {}) {
  const token = localStorage.getItem('token');
  const newOrg = getOrganizationSettings();

  const appid = newOrg.id;

  const response = await api.get('customers/wallets', {
    params: { items_per_page },
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'AppID': appid,
    },
  });
  return response.data;
}

export async function processWalletFunding({ funding_amount, destination_wallet_number_or_uuid, description, transaction_pin, success_redirect_url, cancelled_redirect_url, failed_redirect_url }) {
  const token = localStorage.getItem('token');
  const newOrg = getOrganizationSettings();

  const appid = newOrg.id;
  const response = await api.post('customers/fund-wallet-transaction/process',
    {
      funding_amount,
      destination_wallet_number_or_uuid,
      description,
      transaction_pin,
      success_redirect_url,
      cancelled_redirect_url,
      failed_redirect_url
    },
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'AppID': appid,
      },
    }
  );
  return response.data;
}

export async function initiateWalletFunding({ funding_amount, funding_currency_code, destination_wallet_number_or_uuid, description }) {
  const token = localStorage.getItem('token');
  const newOrg = getOrganizationSettings();

  const appid = newOrg.id;
  const response = await api.post('customers/fund-wallet-transaction/initiate',
    {
      funding_amount,
      funding_currency_code,
      destination_wallet_number_or_uuid,
      description
    },
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'AppID': appid,
      },
    }
  );
  return response.data;
}



export async function initiateWalletSwap({ source_wallet_number_or_uuid, source_wallet_swap_amount, destination_wallet_number_or_uuid, description, transaction_pin }) {
  const token = localStorage.getItem('token');
  const newOrg = getOrganizationSettings();
  const appid = newOrg.id;

  const response = await api.post('customers/wallet-funds-swap/initiate', {
    source_wallet_number_or_uuid,
    source_wallet_swap_amount,
    destination_wallet_number_or_uuid,
    description,
    transaction_pin
  }, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'AppID': appid,
    },
  });
  return response.data;
}

export async function processWalletSwap({ source_wallet_number_or_uuid, source_wallet_swap_amount, destination_wallet_number_or_uuid, description, transaction_pin }) {
  const token = localStorage.getItem('token');
  const newOrg = getOrganizationSettings();
  const appid = newOrg.id;
    const response = await api.post('customers/wallet-funds-swap/process', {
    source_wallet_number_or_uuid,
    source_wallet_swap_amount,
    destination_wallet_number_or_uuid,
    description,
    transaction_pin
  }, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'AppID': appid,
    },
  });
  return response.data;
}

export async function initiateCryptoTransfer({ source_wallet_id, destination_address_code, destination_address_network, amount, description }) {
  const token = localStorage.getItem('token');
  const newOrg = getOrganizationSettings();
  const appid = newOrg.id;

    const response = await api.post('customers/crypto-wallet-transaction/initiate', {
    source_wallet_id,
    destination_address_code,
    destination_address_network,
    amount,
    description
  }, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'AppID': appid,
    },
  });
  return response.data;
}

export async function processCryptoTransfer({ source_wallet_id, destination_address_code, destination_address_network, amount, description, transaction_pin }) {
  const token = localStorage.getItem('token');
  const newOrg = getOrganizationSettings();
  const appid = newOrg.id;
    const response = await api.post('customers/crypto-wallet-transaction/process', {
    source_wallet_id,
    destination_address_code,
    destination_address_network,
    amount,
    description,
    transaction_pin
  }, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'AppID': appid,
    },
  });
  return response.data;
} 